import { render, staticRenderFns } from "./OONotes.vue?vue&type=template&id=204de09e&scoped=true&"
import script from "./OONotes.vue?vue&type=script&lang=ts&"
export * from "./OONotes.vue?vue&type=script&lang=ts&"
import style0 from "./OONotes.vue?vue&type=style&index=0&id=204de09e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204de09e",
  null
  
)

export default component.exports